import { createContext, useContext, useEffect, useState } from "react";
import { GetReceiptApprovationList } from "../../api-layer/receipt-api/GetReceiptApprovationList";
import { consoleLog } from "../../../shared/utils";

const ReceiptApprovationTypeContext = createContext();


export const ReceiptApprovationTypeProvider = ({children}) => {
    const [receiptApprovationTypes, setReceiptApprovationTypes] = useState([]);
    const [rejectedReceiptType, setRejectedReceiptType] = useState(null);
    const [awaitingReceiptType, setAwaitingReceiptType] = useState(null);
    const [approvedReceiptType, setApprovedReceiptType] = useState(null);

    useEffect(() => {
        getReceiptApprovations();
    }, [
        receiptApprovationTypes.length,
    ])

    const getReceiptApprovations = () => {
        GetReceiptApprovationList().then(
            response => {
                // consoleLog({'receipt approvation types' : response.data});
                setReceiptApprovations(response.data);   
            }
        ).catch(
            error => {}
        );
    }

    const setReceiptApprovations = (data) => {
        setReceiptApprovationTypes(data);
        if(data?.length > 0){
            for (const approvationType of data) {
                if(approvationType.name === 'approved'){
                    setApprovedReceiptType(approvationType);
                }
                else if(approvationType.name === 'waiting'){
                    setAwaitingReceiptType(approvationType);
                }
                else if(approvationType.name === 'rejected'){
                    setRejectedReceiptType(approvationType);
                }
              }
        }
    }
    return (
        <ReceiptApprovationTypeContext.Provider
            value={{
                approvedReceiptType,
                awaitingReceiptType,
                rejectedReceiptType,
                receiptApprovationTypes,
            }}
        >
            {children}
        </ReceiptApprovationTypeContext.Provider>
    );
}

export const useReceiptApprovationTypes = () => {
    return useContext(ReceiptApprovationTypeContext);
}